import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Col, Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import RatingModalPage from '../../../containers/masters/Rating/RatingModalPage'
import InputSelect from '../../commons/form/InputSelect'
import InputText from '../../commons/form/InputText'
import InputDecimal from '../../commons/form/InputDecimal'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class RatingMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        organizedUnitId: null,
        name: null,
        description: null,
        import: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchRatingList()
    this.props.actions.fetchOrganizedUnitsAll()
  }

  componentDidUpdate () {
    if (this.props.ouIdFromMaster != null) {
      const form = {
        filters: {
          organizedUnitId: this.props.ouIdFromMaster
        }
      }
      this.props.initialize(form)
      this.handleorganizedUnitComboChange(this.props.ouIdFromMaster)
      this.props.actions.setChangeTabFromConfMaster(null, false)
    }
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchRatingList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchRatingList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleorganizedUnitComboChange (organizedUnitId) {
    if (this.state.filter.organizedUnitId !== organizedUnitId) {
      this.setState({ filter: { ...this.state.filter, organizedUnitId } })
    }
  }

  handleNameChange (value) {
    this.setState({ filter: { ...this.state.filter, name: value } })
  }

  handleImportChange (value) {
    this.setState({ filter: { ...this.state.filter, import: value } })
  }

  handleDescriptionChange (value) {
    this.setState({ filter: { ...this.state.filter, description: value } })
  }

  search () {
    this.props.actions.fetchRatingList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.props.initialize({})
    this.props.reset()
    this.setState({
      filter: {
        organizedUnitId: null,
        name: null,
        description: null,
        import: null
      }
    }, () => {
      this.search()
    })
  }

  render () {
    const {
      t, ratingList, pagesCount, ratingListCount, filter,
      combos: { organizedUnitsAllCombo },
      filter: { page },
      actions: { openRatingModal, fetchRatingList, deleteRating }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'ratingMasterPage' })
    const tKey = 'MASTERS.RATING_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const hasFilters = (this.state.filter.organizedUnitId || this.state.filter.description || this.state.filter.name || this.state.filter.import)
    return (
      <div id="ratingMaster" className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openRatingModal()}>
              <i className='iDocIcon-add-plus'></i>{t(`${tKey}ADD`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                name="filters.organizedUnitId"
                controlLabel={t(`${tKey}OU`)}
                placeholder={t(`${tKey}OU`)}
                valueKey="id"
                labelKey="value"
                options={organizedUnitsAllCombo}
                onInputChange={(value) => this.handleorganizedUnitComboChange(value)}
              />
              <Field
                component={InputText}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                id="filters.name"
                name="filters.name"
                controlLabel={t(`${tKey}NAME`)}
                placeholder={t(`${tKey}NAME`)}
                onInputChange={(value) => this.handleNameChange(value)}
                maxLength={50}
              />
              <Field
                component={InputText}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                id="filters.description"
                name="filters.description"
                controlLabel={t(`${tKey}DESCRIPTION`)}
                placeholder={t(`${tKey}DESCRIPTION`)}
                onInputChange={(value) => this.handleDescriptionChange(value)}
                maxLength={50}
              />
              <Field
                component={InputDecimal}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                id="filters.import"
                name="filters.import"
                controlLabel={t(`${tKey}IMPORT`)}
                placeholder={t(`${tKey}IMPORT`)}
                valueKey="id"
                labelKey="value"
                onChange={(event, value) => this.handleImportChange(value)}
                maxLength={50}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.search()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {ratingList.length !== 0 &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('organizedUnitId') }}>
                        {t(`${tKey}OU`)}
                        <i className={this.getSortIcon('organizedUnitId')} />
                      </th>
                      <th onClick={() => { this.changeOrder('name') }}>
                        {t(`${tKey}NAME`)}
                        <i className={this.getSortIcon('name')} />
                      </th>
                      <th onClick={() => { this.changeOrder('description') }}>
                        {t(`${tKey}DESCRIPTION`)}
                        <i className={this.getSortIcon('description')} />
                      </th>
                      <th onClick={() => { this.changeOrder('import') }}>
                        {t(`${tKey}IMPORT`)}
                        <i className={this.getSortIcon('import')} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ratingList && ratingList.map((rating, idx) => {
                      return (
                        <tr key={idx} className={rating.isDeleted ? 'is-deleted' : ''}>
                          <td>{organizedUnitsAllCombo && organizedUnitsAllCombo.find(x => x.id === rating?.organizedUnitId) && organizedUnitsAllCombo.find(x => x.id === rating?.organizedUnitId).value}</td>
                          <td>{rating.name}</td>
                          <td>{rating.description}</td>
                          <td>{rating.import}€</td>
                          <td className='actions'>
                            {!rating.isDeleted && (
                              <div>
                                <OverlayTrigger placement="left" overlay={editTooltip}>
                                  <a className='_Btn accept stk o-icn ' onClick={() => openRatingModal(rating)}>
                                    <i className="iDocIcon-edit" />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn ' onClick={() => deleteRating(rating.ratingId)}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger>
                              </div>
                            )}
                          </td>
                        </tr>)
                    })}

                  </tbody>
                </Table>
              }
              {(ratingList === null || ratingList === undefined || ratingList.length === 0) &&
            <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={ratingListCount}
                    onSelectAction={(value) => fetchRatingList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>

        <RatingModalPage/>

        <Col sm={12} className="col-row  section-users-body">

        </Col>
      </div>
    )
  }
}

export default reduxForm({
  form: 'rating'
})(RatingMaster)
